import React, {useEffect, useState} from 'react';
import {ContentHistoryProps, HistoryProp} from "./ContentHistory.props";
import {Box, Tooltip, Typography} from "@mui/material";
import './ContentHistory.css';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {DataTables} from "../DataTables";
import {GridColDef, GridRenderCellParams} from "@mui/x-data-grid";
import {parseImgURL} from "../../utils/util";
import {convertUtcToTimezone} from "../../utils/dateTimeHelper";
import moment from "moment/moment";
import {FORMAT_MOMENT, TOOLTIP_MESSAGES} from "../../constants/constants";
import CoursePassed from "../../assets/images/passed-icon-blue.svg";
import ReportedIcon from "../../assets/images/Reported.svg";
import ChangeWorkSpace from "../../hoc/changeWorkSpace";
import {Course_Status} from "../../constants/enums";

const ContentHistoryComponent: React.FC<ContentHistoryProps> = ({text, data = []}) => {

  const [contentData, setContentData] = useState<any[]>([]);

  const mapContentData = (data: HistoryProp[]) => {
    let result;
    if (data && data.length > 0) {
      // filter just to get all items with action_type in statusIcon
      const responses = data.filter((item: HistoryProp)=> Object.prototype.hasOwnProperty.call(statusIcon, item.action_type))
      result = responses.map((res: any) => {
        const assignedDate = res.action_type.includes("REPORT_EMAIL") ? res.metadata?.sent_at : res.metadata?.start_date;
        return ({
          id: res.badge_id || '',
          course_name: res.metadata?.email_subject || res.metadata?.course_name || '',
          assignedDate: assignedDate || '',
          timestamp: res.timestamp || '',
          tp_thumbnail: res.metadata.tp_thumbnail || '',
          tp_id: res.metadata.tp_id || '',
          action_type: res.action_type || '',
        })
      })
    }
    return result || [];
  }

  useEffect(() => {
    const dataMap = mapContentData(data)
    setContentData(dataMap)
  }, [data])

  const statusIcon = {
    COMPLETE_LEARNING_COURSE: CoursePassed,
    REPORT_EMAIL: ReportedIcon,
    REPORT_EMAIL_LINK_BASED: ReportedIcon,
    REPORT_EMAIL_ATTACHMENT_BASED: ReportedIcon,
    REPORT_EMAIL_CREDENTIAL_THEFT: ReportedIcon,
    REPORT_EMAIL_QR_CODE: ReportedIcon,
    REPORT_EMAIL_SPEAR_PHISHING: ReportedIcon,
    REPORT_EMAIL_LINK_BASED_SPEAR_PHISHING: ReportedIcon,
    REPORT_EMAIL_ATTACHMENT_BASED_SPEAR_PHISHING: ReportedIcon,
    REPORT_EMAIL_QR_CODE_SPEAR_PHISHING: ReportedIcon,
    REPORT_EMAIL_CREDENTIAL_THEFT_SPEAR_PHISHING: ReportedIcon,
    REPORT_EMAIL_LINK_BASED_ATTACHMENT_BASED: ReportedIcon,
    REPORT_EMAIL_LINK_BASED_QR_CODE: ReportedIcon,
    REPORT_EMAIL_LINK_BASED_CREDENTIAL_THEFT: ReportedIcon,
    REPORT_EMAIL_ATTACHMENT_BASED_QR_CODE: ReportedIcon,
    REPORT_EMAIL_ATTACHMENT_BASED_CREDENTIAL_THEFT: ReportedIcon,
    REPORT_EMAIL_QR_CODE_CREDENTIAL_THEFT: ReportedIcon,
    REPORT_EMAIL_LINK_BASED_ATTACHMENT_BASED_SPEAR_PHISHING: ReportedIcon,
    REPORT_EMAIL_LINK_BASED_QR_CODE_SPEAR_PHISHING: ReportedIcon,
    REPORT_EMAIL_LINK_BASED_CREDENTIAL_THEFT_SPEAR_PHISHING: ReportedIcon,
    REPORT_EMAIL_ATTACHMENT_BASED_QR_CODE_SPEAR_PHISHING: ReportedIcon,
    REPORT_EMAIL_ATTACHMENT_BASED_CREDENTIAL_THEFT_SPEAR_PHISHING: ReportedIcon,
    REPORT_EMAIL_QR_CODE_CREDENTIAL_THEFT_SPEAR_PHISHING: ReportedIcon,
    REPORT_EMAIL_LINK_BASED_ATTACHMENT_BASED_QR_CODE: ReportedIcon,
    REPORT_EMAIL_LINK_BASED_ATTACHMENT_BASED_CREDENTIAL_THEFT: ReportedIcon,
    REPORT_EMAIL_LINK_BASED_QR_CODE_CREDENTIAL_THEFT: ReportedIcon,
    REPORT_EMAIL_ATTACHMENT_BASED_QR_CODE_CREDENTIAL_THEFT: ReportedIcon,
    REPORT_EMAIL_LINK_BASED_ATTACHMENT_BASED_QR_CODE_SPEAR_PHISHING: ReportedIcon,
    REPORT_EMAIL_LINK_BASED_ATTACHMENT_BASED_CREDENTIAL_THEFT_SPEAR_PHISHING: ReportedIcon,
    REPORT_EMAIL_LINK_BASED_QR_CODE_CREDENTIAL_THEFT_SPEAR_PHISHING: ReportedIcon,
    REPORT_EMAIL_ATTACHMENT_BASED_QR_CODE_CREDENTIAL_THEFT_SPEAR_PHISHING: ReportedIcon,
    REPORT_EMAIL_LINK_BASED_ATTACHMENT_BASED_QR_CODE_CREDENTIAL_THEFT: ReportedIcon,
    REPORT_EMAIL_LINK_BASED_ATTACHMENT_BASED_QR_CODE_CREDENTIAL_THEFT_SPEAR_PHISHING: ReportedIcon
  };

  const columns: GridColDef[] = [
    {
      field: 'course_name',
      headerName: 'Name',
      sortable: false,
      flex: 2,
      headerClassName: 'data-table-header-cell',
      renderCell: (params: GridRenderCellParams) => {
        return <Box className={''} display={'flex'} alignItems={"center"} gap={'10px'}>
          {(params.row.action_type && params.row.action_type.includes('REPORT_EMAIL')) ? <></> : <img src={parseImgURL(params.row.tp_thumbnail, params.row.tp_id)} width={39} height={39}/>}
          {params.value}</Box>;
      }
    },
    {
      field: 'assignedDate',
      headerName: 'Assigned Date',
      flex: 1,
      sortable: false,
      renderCell: (params: GridRenderCellParams) => {
        const utcByTimezone = convertUtcToTimezone(params?.value);
        return (
          <p>{utcByTimezone ? moment(utcByTimezone).format(FORMAT_MOMENT.DATE) : 'N/A'}</p>
        );
      }
    },
    {
      field: 'action_type',
      headerName: 'Action',
      sortable: false,
      flex: 1,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: GridRenderCellParams) => (
        <img src={statusIcon[params.value as Course_Status]} width={45} height={45}/>
      )
    },
    {
      field: 'timestamp',
      headerName: 'Timestamp',
      flex: 1,
      sortable: false,
      headerAlign: 'right',
      align: 'right',
      renderCell: (params: GridRenderCellParams) => {
        const utcByTimezone = convertUtcToTimezone(params?.value);
        return (
          <p>
            <span>{utcByTimezone ? moment(utcByTimezone).format(FORMAT_MOMENT.TIME) : ''}</span> <br />
            <span>{utcByTimezone ? moment(utcByTimezone).format(FORMAT_MOMENT.DATE) : 'N/A'}</span>
          </p>
        );
      }
    }
  ];

  return (
    <>
      {contentData && <div className={'content-history'}>
          <Box sx={{width: '100%'}} mb={'37px'}>
              <Box sx={{width: '100%'}} display="flex" justifyContent="space-between">
                  <Typography sx={{fontFamily: 'Righteous', fontSize: 24, fontWeight: 400, color: '#193051'}}>Content
                      History</Typography>
                  <Typography>
                      <Tooltip
                          title={TOOLTIP_MESSAGES.PROFILE_CONTENT_HISTORY}
                          placement="top-start"
                          arrow
                          componentsProps={{
                            tooltip: {
                              sx: {
                                fontSize: '13px',
                                [`&.MuiTooltip-tooltipPlacementTop`]: {
                                  maxWidth: 'fit-content',
                                },
                              },
                            },
                          }}
                      >
                          <InfoOutlinedIcon sx={{position: "relative", top: "4px", cursor: "pointer"}}
                                            fontSize={"medium"} htmlColor={"#193051"}/>
                      </Tooltip>
                  </Typography>
              </Box>
              <Box sx={{width: '100%'}} display="flex" justifyContent="space-between">
                  <Typography
                      sx={{
                        fontFamily: 'Montserrat',
                        fontSize: 16,
                        fontWeight: 500,
                        color: '#000000',
                        opacity: 0.6,
                        marginTop: '12px'
                      }}>
                      {text}
                  </Typography>
              </Box>
          </Box>
          <DataTables
              tblRows={contentData}
              tblColumns={columns}
              sortingMode='server'
              autoHeight={false}
              totalRows={contentData.length}
          />
      </div>}
    </>
  );
};

export const ContentHistory = ChangeWorkSpace(ContentHistoryComponent);